import { SelectableFiatCurrency } from '@app/unauthenticated/currency-detail/ui/currency-detail.types';
import { selectableCurrencies } from '@app/shared/services/selected-currency.service';

export const URL_PARAM_CURRENCY_PATH = 'currency';

export const selectableFiatCurrencies: SelectableFiatCurrency[] = [...selectableCurrencies];
